var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "my-4" },
    [
      _c("section-title", {
        attrs: { content: "Documentos", icon: "fas fa-file-plus", reverse: "" }
      }),
      _vm.documents.length === 0 ? _c("custom-result-not-found") : _vm._e(),
      _vm._l(_vm.documents, function(item, idx) {
        return _c("div", { key: `type-${idx}` }, [
          _c("div", { staticClass: "bg-secondary-3 mt-3 rounded py-3 px-4" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-6" }, [
                _c("label", { staticClass: "data-title mb-0" }, [
                  _vm._v("Documento:")
                ]),
                _c("h6", [
                  _vm._v(_vm._s(_vm._f("empty")(item.documentTypeName)))
                ])
              ]),
              _c("div", { staticClass: "col-md-4" }, [
                _c("label", { staticClass: "data-title mb-0" }, [
                  _vm._v("Archivo:")
                ]),
                _c("h6", [_vm._v(_vm._s(_vm._f("empty")(item.documentName)))])
              ]),
              _c(
                "div",
                {
                  staticClass:
                    "col-md-2 d-flex align-items-center justify-content-end"
                },
                [
                  _c(
                    "div",
                    { staticClass: "mt-3" },
                    [
                      _vm.canDownloadDocument
                        ? _c("action-button", {
                            staticClass: "mr-2 bg-green border-green",
                            attrs: {
                              id: "download-document" + idx,
                              i: "fas fa-file-download text-white mr-n1 pr-1"
                            },
                            on: {
                              click: function($event) {
                                return _vm.downloadDocument(item)
                              }
                            }
                          })
                        : _vm._e(),
                      _c("action-button", {
                        staticClass: "border-green bg-transparent",
                        attrs: {
                          id: "view-document" + idx,
                          i: "fas fa-search-plus text-green mr-n1 pr-1"
                        },
                        on: {
                          click: function($event) {
                            return _vm.viewDocument(item)
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ])
          ])
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }